import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ChileMap from './ChileMap';
import Referencing from '../utils/Referencing';
import RegionsColor from '../utils/RegionsColor';

function EmployeeDistribution({ title = '', onRequest = false, maxHeight = 250 }) {
  const regions = React.useMemo(() => {
    const obj = {};
    if (typeof title === 'object') {
      title.forEach(costCenter => {
        obj[Referencing(costCenter.name)] = RegionsColor(costCenter.name);
      });
    }
    return obj;
  }, [title]);

  const adjustedMaxHeight = maxHeight > 600 ? 600 : maxHeight;
  return (
    <>
      {!onRequest && (
        <div className="EmployeeDistributionBody">
          <Row>
            <Col xl={6} md={6} xs={12}>
              <div className="mt-3" />
              <ChileMap colorRegion={regions} height={adjustedMaxHeight} />
            </Col>
            <Col xl={6} md={6} xs={12} className="CentralizeTextMap">
              {typeof title === 'object' &&
                title.map(costCenter => (
                  <div className="adjust-margin" key={costCenter.name}>
                    <Col md={5} xs={12} className="CountryContentText IgnorePadding">
                      <p style={{ marginBottom: '1px' }}>{Referencing(costCenter.name)}</p>
                    </Col>
                  </div>
                ))}
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}

export default EmployeeDistribution;
